import MobileLayout from '../../layouts/MobileLayout';
import AppPairingContent from '../shared/AppPairingContent';

type Props = {
  pairingCode: string;
  onCancel: () => void;
  onCompletePairing: () => void;
  onBack?: () => void;
};

export default function MobileAppPairingPage(props: Props) {
  return (
    <MobileLayout>
      <AppPairingContent {...props} />
    </MobileLayout>
  );
}
